import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import SearchBox from '../common/search-box';
import SwitchChildTab from '../common/switch-child-tab';
import Filter from '../common/filter';
import FilterTrustability from '../common/filter-trustability';
import { REDUCER_NAME, setAPIParams } from '../reducer';
import { I18n } from 'react-redux-i18n';
import './index.scss';
import TimeRangeWrapper from '../../common/time-range-wrapper';
const FORMAT_DATE = 'MM/DD/YYYY';

class SwitchTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTrustability: [
        { value: 'LOW', color: 'bg-l-color-3', isChecked: true },
        { value: 'MED', color: 'bg-s-color-4', isChecked: true },
        { value: 'HIGH', color: 'bg-s-color-3', isChecked: true },
      ],
    };
  }

  componentDidMount() {
    const {
      setAPIParams,
      currentTab,
      currentChildTab,
      defaultSearch,
    } = this.props;
    if (defaultSearch) {
      setAPIParams(
        { parentTab: currentTab, childTab: currentChildTab },
        { KeyWord: defaultSearch },
      );
    }
  }

  resetTimeRangeFilter = () => {
    const { setAPIParams, currentTab, currentChildTab } = this.props;
    setAPIParams(
      { parentTab: currentTab, childTab: currentChildTab },
      { FromDate: null, ToDate: null, Page: 1 },
    );
  };

  render() {
    const {
      currentTab,
      handleSwitchTab,
      currentDataGetFrom,
      defaultSearch,
    } = this.props;
    const {
      apiParams: { FromDate, ToDate },
      apiParams,
    } = this.props[currentDataGetFrom];
    return (
      <div className="na-top-content-wrapper">
        <div className="action-content">
          <SearchBox defaultSearch={defaultSearch} apiParams={apiParams} />
          <div
            className={`tabs-right-na d-flex ${
              currentTab === 5
                ? 'justify-content-between'
                : 'justify-content-end'
            }`}
          >
            {currentTab === 5 && <FilterTrustability />}

            {currentTab !== 4 && <Filter FromDate={FromDate} ToDate={ToDate} />}

            {currentTab === 4 && (
              <SwitchChildTab handleSwitchTab={handleSwitchTab} />
            )}
          </div>
        </div>
        {FromDate || ToDate ? (
          <TimeRangeWrapper onClickCloseButton={this.resetTimeRangeFilter}>
            <div className="info-content d-flex align-items-center">
              <div className="main-text">
                {I18n.t(`newsAndAnalysis.filterTime.from`)}
              </div>
              <div className="sub-text">{`${moment(FromDate).format(
                FORMAT_DATE,
              )}`}</div>
              <div className="main-text">
                {I18n.t(`newsAndAnalysis.filterTime.to`)}
              </div>
              <div className="sub-text">{`${moment(ToDate).format(
                FORMAT_DATE,
              )}`}</div>
            </div>
          </TimeRangeWrapper>
        ) : (
          <div style={{ height: 20 }} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { currentDataGetFrom } = props;
  return {
    i18n: state.i18n,
    [currentDataGetFrom]: state[REDUCER_NAME][currentDataGetFrom],
    currentTab: state[REDUCER_NAME].currentTab,
    currentChildTab: state[REDUCER_NAME].currentChildTab,
  };
};
const mapDispatchToProps = {
  setAPIParams,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SwitchTab);
